import styled from 'styled-components';

export const StyledRequirementsSection = styled.div``;
